<script setup>
import {onMounted} from "vue";
import {useUserStore} from "@/store/users";

const userStore = useUserStore();

onMounted(async () => {
  await userStore.getUser()
  if (!userStore.user) location.href = "/login";
})
</script>

<template>
  <div class="layout-container" flex flex-center>
    <div class="layout-content" radius-border>
      <slot></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
.layout-container {
  width: 100%;
  height: 100%;
}

.layout-content {
  width: 90%;
  height: 90%;

  max-width: 1300px;
  max-height: 500px;
  background: white;

  padding: 3em;

  overflow-y: auto;
}
</style>